
import { Component, Vue, Prop, Model } from 'vue-property-decorator';
import { Reintegro } from '@/models';
import dayjs from 'dayjs';

@Component
export default class ItemListReintegro extends Vue {
    @Prop() private reintegro!: Reintegro;

    private showDetail(reintegro: Reintegro) {
        this.$router.push({ name: 'reintegro', params: { id: reintegro.id }});
    }    
}
